import axios from 'axios';

import { GetNotesResponseModel } from '../../../models/notes/getNotesResponse.model';
import { NotesFormPayloadModel } from '../../../models/notes/notesFormPayload.model';
import { NotesItemModel } from '../../../models/notes/notesItem.model';

const notesEndpoints = {
  addNotesItem: (
    params: NotesFormPayloadModel & {
      entity_type?: string;
      entity_id?: number;
    },
  ): Promise<NotesItemModel> => axios.post(`/notes`, params),
  getNotes: (params: {
    page: number;
    entity_type?: string;
    entity_id?: number;
  }): Promise<GetNotesResponseModel> => axios.get('/notes', { params }),
  deleteNotesItem: (params: { itemId: number; entity_type?: string; entity_id?: number }): Promise<number> =>
    axios.delete(`/notes/${params.itemId}`, { params }),
};

export default notesEndpoints;
